<template>
  <div class="my-promotion">
    <div class="header">
      <div class="name acea-row row-center-wrapper">
        <div>当前佣金</div>
        <!--        <router-link class="record" :to="'/user/cashrecord'">-->
        <!--          提现记录<span class="iconfont icon-xiangyou"></span>-->
        <!--        </router-link>-->
      </div>
      <div class="num">{{ commission || 0 }}</div>
      <div class="profit acea-row row-between-wrapper">
        <div class="item">
          <div>今日收益</div>
          <div class="money">{{ yesterDay || 0 }}</div>
        </div>
        <div class="item">
          <div>昨日收益</div>
          <div class="money">{{ nowDay || 0 }}</div>
        </div>
      </div>
    </div>
    <div class="bnt bg-color-red" @click="toCash">立即赚钱</div>
    <div class="list acea-row row-between-wrapper">
      <router-link
        class="item acea-row row-center-wrapper row-column"
        :to="`/activity/poster/${id}`"
      >
        <span class="iconfont icon-erweima"></span>
        <div>推广名片</div>
      </router-link>

      <router-link
        class="item acea-row row-center-wrapper row-column"
        :to="{ name: 'ActPromoterList' }"
      >
        <span class="iconfont icon-tongji"></span>
        <div>推广人统计</div>
      </router-link>

      <router-link
        class="item acea-row row-center-wrapper row-column"
        :to="`/activity/commission/${id}`"
      >
        <span class="iconfont icon-qiandai"></span>
        <div>佣金明细</div>
      </router-link>

      <router-link
        class="item acea-row row-center-wrapper row-column"
        :to="`/activity/promoter/order/${id}`"
      >
        <span class="iconfont icon-dingdan"></span>
        <div>推广人订单</div>
      </router-link>

      <router-link
        class="item acea-row row-center-wrapper row-column"
        :to="`/activity/promoter/rank/${id}`"
      >
        <span class="iconfont icon-paihang1"></span>
        <div>推广人排行</div>
      </router-link>

      <router-link
        class="item acea-row row-center-wrapper row-column"
        :to="`/activity/commission/rank/${id}`"
      >
        <span class="iconfont icon-paihang"></span>
        <div>佣金排行</div>
      </router-link>
    </div>
  </div>
</template>
<script>
import {
  commissionTotal,
  yesterdayCommission,
  nowCommission,
} from "@/api/activity";

export default {
  name: "UserPromotion",
  components: {},
  props: {},
  data: function () {
    return {
      id: this.$route.params.id,
      commission: 0,
      nowDay: 0,
      yesterDay: 0,
      userInfo: {},
    };
  },
  mounted: function () {
    this.getCommissionTotal();
    this.getNowCommission();
    this.getYesterDayCommission();
  },
  methods: {
    getCommissionTotal() {
      commissionTotal(this.id).then((res) => {
        this.commission = res.result || 0;
      });
    },
    getNowCommission() {
      nowCommission(this.id).then((res) => {
        this.nowDay = res.result || 0;
      });
    },
    getYesterDayCommission() {
      yesterdayCommission(this.id).then((res) => {
        this.yesterDay = res.result || 0;
      });
    },
    toCash: function () {
      this.$router.push({ path: `/activity/poster/${this.id}` });
    },
  },
};
</script>
